import React from 'react';
import _get from 'lodash/get';
import TaskCompletionForm from 'components/TaskCompletionForm/TaskCompletionForm';
import getValues from 'routes/Task/utils/getValues';
import useFields from './utils/useFields';
import useActions from './utils/useActions';

function TaskCompletionViewContainer() {
  const {
    id = '',
    taskDataForCompletion,
    taskFormTemplateVersion,
    taskCompletionError,
    taskCompletionLoading = false,
    formRef,
  } = useActions();
  const questions = _get(taskFormTemplateVersion, 'questions', []);
  const answers = _get(taskDataForCompletion, 'completion.answers', []);
  const { formFields } = useFields([...questions], [], true);
  const defaultValues = getValues(answers);

  return (
    <TaskCompletionForm
      defaultValues={defaultValues}
      disableAwayConfirmation
      error={taskCompletionError}
      fields={formFields}
      formRef={formRef}
      id={id}
      loading={taskCompletionLoading}
      taskCompletionError={taskCompletionError}
    />
  );
}

export default TaskCompletionViewContainer;
